import React from 'react';
import styles from './PageTitle.module.css';

interface PageTitleProps {
    title: string;
    description?: string;
    className?: string; // Permitir clases extra si es necesario
}

export const PageTitle: React.FC<PageTitleProps> = ({ title, description, className }) => {
    return (
        <div className={`${styles.container} ${className || ''}`}>
            <h1 className={styles.title}>{title}</h1>
            {description && <p className={styles.description}>{description}</p>}
        </div>
    );
};
